// Section 17 and 18: Water ration policy. Equal / Sick first / Workers first / Manual
// (config.rationing.waterPlans maps them to the engine). The preview counts who drinks first.
// Default: config.policies.defaults.waterRation.
import type { Config } from '../../config';
import { noChangeCost, noProblem } from '../../core/content-helpers';
import { peopleSorted } from '../../core/queries';
import { definePolicy, noModifiers } from '../../core/registry';

export function waterRation(config: Config) {
  return definePolicy({
    id: 'waterRation',
    label: 'Water ration',
    section: 'S18',
    group: 'rations',
    options: ['equal', 'sick-first', 'workers-first', 'manual'],
    default: config.policies.defaults.waterRation,
    modifierTargets: [],
    modifiers: noModifiers,
    changeCost: noChangeCost,
    affects(ctx, option) {
      const people = peopleSorted(ctx.state);
      const first = new Set<string>();
      for (const id of config.rationing.waterPlans[option].order) {
        if (id === 'everyone-else') continue;
        for (const p of ctx.registry.priorityGroups[id].members(ctx)) first.add(p);
      }
      return [
        {
          key: `policy.waterRation.${option}`,
          params: { count: first.size, people: people.length },
        },
      ];
    },
    validate: noProblem,
  });
}
